<!--模板-->
<template>
  <div class="zwcWidth">
    <!-- 手机快速登录 -->
    <div class="zwcWidth banner">
      <div class="white_box">
        <el-form>
          <el-row style="padding: 60px 20px;">
            <!-- <p class="text-title" @click="showModule(-1)" :class='{active:faceValue1}' style="border-right: 1px solid #F2F2F2;">密码登录</p> -->
            <p class="text-title" @click="showModule(1)" :class='{active:faceValue}'>快捷登录/注册</p>
          </el-row>
          <div v-if="show">
            <el-form-item style="margin-bottom: 40px;">
              <el-input placeholder="请输入手机号" v-model="telphone" maxlength="11" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入验证码" style="width: 180px; margin-right: 62px;" v-model="code" clearable></el-input>
              <!-- <el-input v-model="input" placeholder="输入验证码" style="width: 70%"  clearable></el-input> -->
              <el-button type="primary" :disabled="d" round :plain="false" @click="smsBtn()" style="border-radius: 0; width: 118px; padding: 12px 0px;">
                <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                <span v-if="!sendMsgDisabled">发送验证码</span>
              </el-button>
            </el-form-item>
            <el-form-item>
              <p><span style="font-size: 12px;color:#666666;">点击登录，表示同意 <span style="color: #35B8DF;cursor: pointer;" @click="tcp('1')">《陪伴玩服务协议》</span>和<span style="color: #35B8DF;cursor: pointer;" @click="tcp('2')">《隐私政策》</span></span></p>
              <p class="enter">
                <el-button type="primary" style="width: 100%" @click="login_btn()">登录</el-button>
              </p>
            </el-form-item>
            <!-- 其他选择 -->
            <!-- <el-row :gutter="20" style="margin-top: 50px;">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <a @click="regBtn()">注册账号</a>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple" :style="{textAlign: 'right'}">
                  <a @click="passlogin()">忘记密码?</a>
                </div>
              </el-col>
            </el-row> -->
          </div>
          <div v-else>
            <el-form-item style="margin-bottom: 40px;">
              <el-input placeholder="请输入手机号" v-model="telphone" maxlength="11" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="请输入密码" v-model="password" type="password" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <p style="font-size: 12px"><span>点击登录，表示同意 <span style="color: #35B8DF;cursor: pointer;" @click="tcp('1')">《陪伴玩服务协议》</span>和<span style="color: #35B8DF;cursor: pointer;" @click="tcp('2')">《隐私条款》</span></span></p>
              <p class="enter">
                <el-button type="primary" style="width: 100%" @click="login_pass()">登录</el-button>
              </p>
            </el-form-item>
            <!-- 其他选择 -->
            <el-row :gutter="20" style="margin-top: 50px;">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <a @click="regBtn()">注册账号</a>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple" :style="{textAlign: 'right'}">
                  <a @click="passlogin()">忘记密码?</a>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
    <!--    协议-->
    <tcp :textShow="textShow" :tcpId="tcpId"></tcp>
  </div>
</template>

<!--JS-->
<script>

import http from 'api/api'
import tcp from '../../components/common/tcp.vue'
import $ from 'jquery'

export default {
  components: {
    tcp
  },
  data () {
    return {
      activeName: 'second',
      show: true,
      faceValue: false,
      faceValue1: true,
      telphone: '',
      code: '',
      password: '',
      time: 60, // 发送验证码倒计时
      sendMsgDisabled: false,
      d: false, //控制按钮是否禁止点击
      textShow: false,
      tcpId: ''
    }
  },
  methods: {
    tcp (id) {
      this.textShow = !this.textShow
      this.tcpId = id
    },
    regBtn () {
      // this.$message.error("暂不开放，可先关注微信公众号【陪伴玩wan】，敬请期待！~");
      // return
      this.$router.push('/register')
    },
    passlogin () {
      this.$router.push('/retrievePwd')
    },
    showModule (a) {
      if (a == 1) {
        this.show = true;
        this.faceValue = true;
        this.faceValue1 = false;
      } else {
        this.show = false;
        this.faceValue = false;
        this.faceValue1 = true;
      }
    },
    // 验证码登录
    login_btn () {
      if (this.telphone == '' || !(/^1[34578]\d{9}$/.test(this.telphone)) || this.telphone.length < 11) {
        this.$message.error("请输入正确手机号");
        return
      }
      if (this.code == '') {
        this.$message.error("请输入正确验证码")
        return
      }

      http.POST('/jw-user', {
        module: 'user',
        operation: 'login',
        code: this.code,
        username: this.telphone
      }).then((res) => {
        if (res.status == 1) {
          this.$message.success("登录成功");
          let user = {
            username: res.data.username,
            uid: res.data.uid
          }
          localStorage.setItem("pbw_user_pc_uid", res.data.uid)
          localStorage.setItem("pbw_user", JSON.stringify(user))
          localStorage.setItem("pbw_user_pc_token", res.data.token)
          this.$router.push('/home/personal');
        } else {
          this.$message.error(res.msg);
        }
      })

    },
    // 发送验证码
    smsBtn () {
      if (this.telphone == '' || !(/^1[34578]\d{9}$/.test(this.telphone)) || this.telphone.length < 11) {
        this.$message.error("请输入正确手机号");
        return
      }
      this.sendMsgDisabled = true;
      this.d = true; //倒计时禁止点击
      let interval = window.setInterval(() => {
        if ((this.time--) <= 0) {
          this.time = 60;
          this.sendMsgDisabled = false;
          this.d = false;
          window.clearInterval(interval);
        }
      }, 1000);
      http.POST('/jw-sms', {
        module: 'smsCode',
        operation: 'send',
        TemplateCode: 'SMS_199806225',
        action: '用户',
        mobile: this.telphone
      }).then((res) => {
        if (res.status == 1) {
          this.$message.success("已发送，请查收");
        } else {
          this.$message.error(res.msg);
          this.sendMsgDisabled = false;
          this.d = false;
        }
      })
    },

    // 密码登录
    login_pass () {
      let vm = this;
      if (vm.telphone == '' || !(/^1[34578]\d{9}$/.test(vm.telphone)) || vm.telphone.length < 11) {
        vm.$message.error("请输入正确手机号");
        return
      } else if (vm.password == '' || vm.password.length < 6 || vm.password.length > 16) {
        vm.$message.error("密码必须为字母加数字且长度6~16位");
        return
      }
      api_pwd({ 'telphone': vm.telphone, 'address': vm.password, 'registType': '3' }).then((res) => {
        if (res.status == 1) {
          vm.$message.success("登录成功");
          vm.$router.push('/home/personal');
          localStorage.setItem("pbw_user_pc_uid", res.data.uid)
          localStorage.setItem("pbw_user_pc_token", res.data.token)
        } else {
          vm.$message.error(res.msg);
        }
      })
    }
  },
  mounted: function () {
    // 获取是否有送来的手机号
    if (this.$route.query.phone) {
      this.telphone = this.$route.query.phone
    }
    // 登录失效
    if (this.$route.query.type == 'lose') {
      this.$message.error("登录已失效，请重新登录");
    }

  }
}
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../scss/commonH5.scss';

/*外层样式*/
.zwcWidth {
  width: 100%;
}
/*内层居中样式*/
.seconedWidth {
  width: 1000px;
  margin: 0 auto;
}

// header头部
#header {
  height: 80px;
  // padding: 30px 0;
}
#header > div:first-child {
  padding-top: 15px;
}
#header img {
  display: block;
  width: 120px;
}

/*手机快速登录*/
.banner {
  background: url(../../../static/images/title/login.jpg) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 640px;
  position: relative;
}
.banner .white_box {
  background-color: #ffffff;
  width: 365px;
  height: 530px;
  position: absolute;
  top: 55px;
  left: 50%;
  padding: 0 40px;
  border-radius: 10px;
}
.white_box .text-title {
  display: inline-block;
  width: 50%;
  text-align: center;
  font-size: 25px;
  float: left;
  box-sizing: border-box;
  cursor: pointer;
  color: #666666;
}
.white_box .text-title.active {
  /*background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(rgb(252, 96, 12)), to(rgb(207, 7, 57)));*/
  color: $fontColor;
  /*-webkit-background-clip: text;*/
  /*-webkit-text-fill-color: transparent;*/
}

/* 下-底部 */
.b_base {
  margin: auto;
  display: table;
}
.b_base ul li {
  float: left;
}
.b_base ul li a {
  border-right: 2px solid #b4b4b4;
  padding-right: 5px;
  padding-left: 5px;
  color: #b4b4b4;
  font-size: 12px;
  cursor: pointer;
}
.record {
  text-align: center;
  color: #b4b4b4;
  font-size: 12px;
}

.white_box .grid-content a {
  color: #333333;
  font-size: 16px;
  cursor: pointer;
}
.white_box .grid-content a:hover {
  color: $fontColor;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue